import { AlertTriangle, RefreshCw } from 'lucide-react';

interface CatalogueErrorProps {
  onRetry: () => void;
  lang: 'fr' | 'en';
}

export function CatalogueError({ onRetry, lang }: CatalogueErrorProps) {
  return (
    <div className="py-24 text-center">
      <div className="w-20 h-20 rounded-full bg-gray-100 flex items-center justify-center mx-auto mb-5">
        <AlertTriangle size={36} className="text-gray-400" />
      </div>
      <h3 className="text-lg font-bold text-gray-900 mb-2">
        {lang === 'fr' ? 'Impossible de charger les produits' : 'Unable to load products'}
      </h3>
      <p className="text-sm text-gray-500 mb-6 max-w-sm mx-auto">
        {lang === 'fr' 
          ? 'Une erreur est survenue lors du chargement. Vérifiez votre connexion et réessayez.'
          : 'An error occurred while loading. Check your connection and try again.'}
      </p>
      <button
        onClick={onRetry}
        className="inline-flex items-center gap-2 px-5 py-2.5 bg-lodiss-red hover:bg-lodiss-dark text-white text-sm font-semibold rounded-lg transition-colors"
      >
        <RefreshCw size={16} />
        {lang === 'fr' ? 'Réessayer' : 'Try again'}
      </button>
    </div>
  );
}
